import React, { DragEventHandler, HTMLProps, TouchEventHandler } from "react"

interface DraggableProps extends HTMLProps<HTMLDivElement> {
  children: React.ReactNode
  isDisabled?: boolean
  className?: string
  onTouchStart?: TouchEventHandler
  onTouchEnd?: TouchEventHandler
  onDragStart?: DragEventHandler
  onDragEnd?: DragEventHandler
}

export const Draggable = React.memo(
  React.forwardRef(
    (
      {
        children,
        isDisabled,
        onTouchStart,
        onTouchEnd,
        onDragStart,
        onDragEnd,
        ...props
      }: DraggableProps,
      ref: React.ForwardedRef<HTMLDivElement>
    ) => (
      <div
        ref={ref}
        draggable={!isDisabled}
        {...props}
        onTouchStart={isDisabled ? undefined : onTouchStart}
        onTouchEnd={isDisabled ? undefined : onTouchEnd}
        onDragStart={isDisabled ? undefined : onDragStart}
        onDragEnd={isDisabled ? undefined : onDragEnd}
      >
        {children}
      </div>
    )
  )
)
